var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"width-100 height-100"},[_c('AnalyticsTotalRunsGraphCard'),_c('div',{staticClass:"mt-5 display-flex cards-container"},[_c('AnalyticsTopUsersCard'),_c('AnalyticsTopFeaturesCard',{staticClass:"features-card"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }